<script>
  export let id, label, type, name, value, required, readonly, oninput
</script>

<label for="{id}">
  {label}{required ? ' *' : ''}
</label>
<input id={id} type={type} name={name ? name : null}
  value={value || null}
  required={required ? 'required' : null}
  readonly={readonly ? 'readonly' : null}
  on:input={oninput}
>

<style lang="scss">
  @import '../../scss/media-sizes';
  input {
    background-color: var(--color_10);
    color: var(--color_3);
    border-radius: 6px;
    padding: 12px;
    width: 100%;
    &:global(:readonly) {
      opacity: .6;
      cursor: default;
    }
  }
  @media screen and (max-width: $mediaQueryMid) {
    input {
      font-size: 18px;
      padding: 15px;
    }
  }
</style>